import { isFunction } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import TileA from '../TileA/TileA.jsx';

import './ThemedTile.scss';

const ThemedTile = ({ children, theme }) => {
    if (!isFunction(children)) {
        return null;
    }

    let TileComponent = null;
    let tileTheme = String(theme);
    switch (String(theme).toLowerCase()) {
        case 'a':
        case 'tile-a':
        case 'widget-tile-a':
            TileComponent = TileA;
            tileTheme = 'tile-a';
            break;
        default:
            TileComponent = null;
    }

    return <div className="ThemedTile">{children(TileComponent, { theme: tileTheme })}</div>;
};

ThemedTile.defaultProps = {
    theme: 'tile-a',
};

ThemedTile.propTypes = {
    children: PropTypes.func.isRequired,
    theme: PropTypes.string,
};

ThemedTile.displayName = 'ThemedTile';

export default ThemedTile;
